.container {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 16px;
    padding-bottom: 48px;
}
